import xls from "xlsx";
import { saveAs } from "file-saver";
import * as _ from "lodash";
import { toast } from "react-toastify";

// Builds a professional, filesystem-safe export file name of the form
// "Company Name - Report Title - Offer ID - DD-MM-YYYY". Strips characters
// that are invalid in Windows/macOS/Linux file names (company names can
// contain "/", "&", etc.) and collapses stray whitespace/dashes left behind.
export function buildExportFileName(parts) {
  const cleaned = parts
    .filter((part) => part !== undefined && part !== null && String(part).trim() !== "")
    .map((part) =>
      String(part)
        .trim()
        .replace(/[\\/:*?"<>|]/g, "-")
        .replace(/\s+/g, " ")
    );
  return cleaned.join(" - ").replace(/-{2,}/g, "-").trim();
}

export function getvalidDateDMY(date) {
  if (date === "" || date === undefined) {
    return "";
  } else {
    const resdate = new Date(date);
    const year = resdate.getFullYear();
    const month =
      (resdate.getMonth() + 1).toString().length === 1
        ? "0" + (resdate.getMonth() + 1)
        : (resdate.getMonth() + 1).toString();
    const day =
      resdate.getDate().toString().length === 1
        ? "0" + resdate.getDate()
        : resdate.getDate().toString();
    return day + "-" + month + "-" + year;
  }
}

export function getvalidDateDMonthY(date) {
  const resdate = new Date(date);
  const year = resdate.getFullYear();
  const months = [
    "January",
    "Feburary",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const month = months.find((month, i) => i === resdate.getMonth());
  const day =
    resdate.getDate().toString().length === 1
      ? "0" + resdate.getDate()
      : resdate.getDate().toString();
  return day + " " + month + ", " + year;
}

export function generateExcel(
  file_name,
  title,
  subject,
  sheet_name,
  author,
  headings,
  columns,
  file_data,
  footers = [""]
) {
  //if(item[key]?.toString()) obj[key]=item[key]  Replace for converting Number from String to Number
  const arr = [];

  if (file_data?.length) {
    file_data.map((item) => {
      const obj = {};
      const keys = Object.keys(item);
      keys.map((key) => {
        if (item[key]?.toString())
          obj[key] =
            typeof item[key] === "number"
              ? item[key]
              : (key == "No._of_shares" || key == "percentage_of_holding") &&
                !isNaN(Number(item[key]))
              ? Number(item[key]?.toString().replace(/,/g, ""))
              : item[key]?.toString();
        else obj[key] = " ";
      });
      arr.push(obj);
    });
  }
  const work_book = xls.utils.book_new();
  work_book.Props = {
    Title: title,
    Subject: subject,
    Author: author,
    CreatedDate: new Date(),
  };
  work_book.SheetNames.push(sheet_name);

  const sheet_data = xls.utils.aoa_to_sheet([
    ...headings,
    columns,
    ...arr?.map((row) => _.values(row)),
    footers,
  ]);

  // Create a font style
  const font = {
    fontFamily: "Arial",
    bold: true, // Set to true if you want bold font
    color: "rgb(191, 76, 76)",
  };

  const range = xls.utils.decode_range(sheet_data["!ref"]);
  for (
    let rowNum = range.s.r + headings.length;
    rowNum <= range.e.r - footers.length;
    rowNum++
  ) {
    for (let colNum = range.s.c; colNum <= range.e.c; colNum++) {
      const cell = sheet_data[xls.utils.encode_cell({ r: rowNum, c: colNum })];
      if (cell && cell.t === "s") {
        cell.s = { font };
      }
    }
  }


  sheet_data["!cols"] = fitToColumn([columns]);
  work_book.Sheets[sheet_name] = sheet_data;
  const work_book_export = xls.write(work_book, {
    bookType: "xlsx",
    type: "binary",
    raw: false,
    defval: "",
  });
  saveAs(
    new Blob([s2ab(work_book_export)], { type: "application/octet-stream" }),
    `${file_name}.xlsx`
  );
}
// export function generateExcel(
//   file_name,
//   title,
//   subject,
//   sheet_name,
//   author,
//   headings,
//   columns,
//   file_data,
//   footers = [""]
// ) {
//   const work_book = xls.utils.book_new();
//   work_book.Props = {
//     Title: title,
//     Subject: subject,
//     Author: author,
//     CreatedDate: new Date(),
//   };
//   work_book.SheetNames.push(sheet_name);
//   const sheet_data = xls.utils.aoa_to_sheet([
//     ...headings,
//     columns,
//     ...file_data.map((row) => _.values(row)),
//     footers,
//   ]);
//   sheet_data["!cols"] = fitToColumn([columns]);
//   work_book.Sheets[sheet_name] = sheet_data;
//   const work_book_export = xls.write(work_book, {
//     bookType: "xlsx",
//     type: "binary",
//     raw: false,
//     defval: "",
//   });
//   saveAs(
//     new Blob([s2ab(work_book_export)], { type: "application/octet-stream" }),
//     `${file_name}.xlsx`
//   );
// }
export function getvalidDateDMMMY(date) {
  const resdate = new Date(date);
  const year = resdate.getFullYear();
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = months.find((month, i) => i === resdate.getMonth());
  const day =
    resdate.getDate().toString().length === 1
      ? "0" + resdate.getDate()
      : resdate.getDate().toString();
  return day + "-" + month + "-" + year;
}
export function getvalidDateYMD(date) {
  const resdate = new Date(date);
  const year = resdate.getFullYear();
  const month =
    (resdate.getMonth() + 1).toString().length === 1
      ? "0" + (resdate.getMonth() + 1)
      : (resdate.getMonth() + 1).toString();
  const day =
    resdate.getDate().toString().length === 1
      ? "0" + resdate.getDate()
      : resdate.getDate().toString();
  return year + "-" + month + "-" + day;
}

export function convertDateFormat(dateString) {
  if (!dateString) {
    return null;
  }
  // Split the date string into day, month, and year components
  const parts = dateString.split("/");

  // Rearrange the components into the desired order
  const year = parts[2];
  const month = parts[1].padStart(2, "0");
  const day = parts[0].padStart(2, "0");

  // Combine the components into a new date string
  const newDateString = `${year}-${month}-${day}`;

  return newDateString;
}

export function s2ab(s) {
  const buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
  const view = new Uint8Array(buf); //create uint8array as viewer
  for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
  return buf;
}

export function fitToColumn(arrayOfArray) {
  // get maximum character of each column
  return arrayOfArray[0].map((a, i) => ({
    wch: Math.max(
      ...arrayOfArray.map((a2) => (a2[i] ? a2[i].toString().length : 0))
    ),
  }));
}

// Pure: derives both summary views from the raw subscription rows —
// (1) "Subscription details": category-only totals (No. of Applications /
// No. of Units / Amount), and (2) the bank x category matrix with a
// per-bank Grand Summary. No side effects, so it can drive both a modal
// preview and the Excel export off the exact same numbers.
export function buildBankCategorySummary(rows, categories, bucketFn) {
  const banks = Array.from(
    new Set(rows.map((r) => r.bank_name || "Unknown"))
  ).sort();

  const bankStats = {};
  banks.forEach((bank) => {
    bankStats[bank] = {};
    categories.forEach((c) => {
      bankStats[bank][c.key] = { applications: 0, units: 0, amount: 0 };
    });
  });

  const categoryTotals = {};
  categories.forEach((c) => (categoryTotals[c.key] = { applications: 0, units: 0, amount: 0 }));

  let skippedInvalid = 0;
  rows.forEach((r) => {
    const bank = r.bank_name || "Unknown";
    const shares = Number(r.shares_applied_for) || 0;
    const bucketKey = bucketFn(shares);
    if (!bucketKey) {
      skippedInvalid += 1;
      return;
    }
    const amount = Number(r.amount_pkr) || 0;
    const stat = bankStats[bank][bucketKey];
    stat.applications += 1;
    stat.units += shares;
    stat.amount += amount;
    categoryTotals[bucketKey].applications += 1;
    categoryTotals[bucketKey].units += shares;
    categoryTotals[bucketKey].amount += amount;
  });

  const bankGrandTotals = {};
  const grandTotals = { applications: 0, units: 0, amount: 0 };
  banks.forEach((bank) => {
    let bankApps = 0;
    let bankUnits = 0;
    let bankAmount = 0;
    categories.forEach((c) => {
      const stat = bankStats[bank][c.key];
      bankApps += stat.applications;
      bankUnits += stat.units;
      bankAmount += stat.amount;
    });
    bankGrandTotals[bank] = { applications: bankApps, units: bankUnits, amount: bankAmount };
    grandTotals.applications += bankApps;
    grandTotals.units += bankUnits;
    grandTotals.amount += bankAmount;
  });

  return { banks, bankStats, categoryTotals, bankGrandTotals, grandTotals, skippedInvalid };
}

// Writes the two-table workbook ("Subscription details" + bank x category
// matrix) that buildBankCategorySummary's numbers feed. All numeric cells
// are written as real numbers (not strings) so Excel treats them as
// numeric data throughout. If `rejectedRows` is given (non-empty), a second
// sheet listing every rejected application (name, CNIC, shares applied,
// application number, reason) is added to the same workbook. If
// `underwriterRows` is given (non-empty), a third sheet listing every
// underwriter the offer's leftover (undersubscribed) shares went to is
// added too — underwriters never went through the application/bank/tier
// process the main matrix summarizes, so they're kept as their own sheet
// rather than folded into it, with their own totals.
export function exportBankCategorySummaryExcel({
  fileName,
  detailsTitle,
  bankTableTitle,
  categories,
  summary,
  rejectedRows,
  underwriterRows,
}) {
  const { banks, bankStats, categoryTotals, bankGrandTotals, grandTotals } = summary;

  // Table 1: "Subscription details" — category-only totals.
  const detailsHeader = ["Application Category of Units", "No. of Applications", "No. of Units", "Amount (Rs.)"];
  const detailsRows = categories.map((c) => [
    c.label,
    categoryTotals[c.key].applications,
    categoryTotals[c.key].units,
    categoryTotals[c.key].amount,
  ]);
  const detailsTotalRow = [
    "Total",
    grandTotals.applications,
    grandTotals.units,
    grandTotals.amount,
  ];

  // Table 2: bank x category matrix with per-bank Grand Summary.
  const bankHeaderRow1 = ["Sr. No.", "Bank Name"];
  const bankHeaderRow2 = ["", ""];
  categories.forEach((c) => {
    bankHeaderRow1.push(c.label, "", "");
    bankHeaderRow2.push("Total No. of Applications", "Total No. of Units", "Total Amount (Rs.)");
  });
  bankHeaderRow1.push("Grand Summary", "", "");
  bankHeaderRow2.push("Total No. of Applications", "Total No. of Units", "Total Amount (Rs.)");

  const bankDataRows = banks.map((bank, index) => {
    const row = [index + 1, bank];
    categories.forEach((c) => {
      const stat = bankStats[bank][c.key];
      row.push(stat.applications, stat.units, stat.amount);
    });
    const gt = bankGrandTotals[bank];
    row.push(gt.applications, gt.units, gt.amount);
    return row;
  });
  const bankTotalRow = ["", "Total"];
  categories.forEach((c) => {
    const t = categoryTotals[c.key];
    bankTotalRow.push(t.applications, t.units, t.amount);
  });
  bankTotalRow.push(grandTotals.applications, grandTotals.units, grandTotals.amount);
  bankDataRows.push(bankTotalRow);

  const detailsCols = 4;
  const bankCols = 2 + categories.length * 3 + 3;
  const totalCols = Math.max(detailsCols, bankCols);

  const detailsStartRow = 1;
  const bankTitleRow = detailsStartRow + 1 + detailsRows.length + 1 + 2; // +Total row, +blank, +blank
  const bankHeaderStartRow = bankTitleRow + 2;

  const aoa = [
    [detailsTitle],
    detailsHeader,
    ...detailsRows,
    detailsTotalRow,
    [],
    [],
    [bankTableTitle],
    [],
    bankHeaderRow1,
    bankHeaderRow2,
    ...bankDataRows,
  ];

  const worksheet = xls.utils.aoa_to_sheet(aoa);

  const merges = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: detailsCols - 1 } },
    { s: { r: bankTitleRow, c: 0 }, e: { r: bankTitleRow, c: bankCols - 1 } },
    { s: { r: bankHeaderStartRow, c: 0 }, e: { r: bankHeaderStartRow + 1, c: 0 } },
    { s: { r: bankHeaderStartRow, c: 1 }, e: { r: bankHeaderStartRow + 1, c: 1 } },
  ];
  categories.forEach((c, i) => {
    const startCol = 2 + i * 3;
    merges.push({
      s: { r: bankHeaderStartRow, c: startCol },
      e: { r: bankHeaderStartRow, c: startCol + 2 },
    });
  });
  const grandStartCol = 2 + categories.length * 3;
  merges.push({
    s: { r: bankHeaderStartRow, c: grandStartCol },
    e: { r: bankHeaderStartRow, c: grandStartCol + 2 },
  });
  worksheet["!merges"] = merges;
  worksheet["!cols"] = new Array(totalCols).fill({ wch: 15 });
  worksheet["!cols"][1] = { wch: 18 };

  // Keep every count/amount cell a real number (so it stays summable in
  // Excel) but format it with thousand separators for readability, matching
  // the comma-formatted preview shown in the modal.
  const range = xls.utils.decode_range(worksheet["!ref"]);
  for (let r = range.s.r; r <= range.e.r; r++) {
    for (let c = range.s.c; c <= range.e.c; c++) {
      const cell = worksheet[xls.utils.encode_cell({ r, c })];
      if (cell && cell.t === "n") cell.z = "#,##0";
    }
  }

  const workbook = xls.utils.book_new();
  workbook.Props = { Title: "Subscription Summary", CreatedDate: new Date() };
  workbook.SheetNames.push("Summary");
  workbook.Sheets["Summary"] = worksheet;

  if (rejectedRows && rejectedRows.length) {
    const rejectedHeader = [
      "S. No.",
      "Name of Applicant",
      "CNIC / NTN",
      "Shares Applied",
      "Application Number",
      "Reason of Rejection",
    ];
    const rejectedDataRows = rejectedRows.map((r, index) => [
      index + 1,
      r.name_of_applicant || "",
      r.cnic_ntn || "",
      Number(r.shares_applied_for) || 0,
      r.application_no || "",
      r.reason || "",
    ]);
    const rejectedSheet = xls.utils.aoa_to_sheet([rejectedHeader, ...rejectedDataRows]);
    rejectedSheet["!cols"] = [
      { wch: 8 },
      { wch: 28 },
      { wch: 18 },
      { wch: 14 },
      { wch: 20 },
      { wch: 28 },
    ];
    const rejectedRange = xls.utils.decode_range(rejectedSheet["!ref"]);
    for (let r = rejectedRange.s.r; r <= rejectedRange.e.r; r++) {
      const cell = rejectedSheet[xls.utils.encode_cell({ r, c: 3 })];
      if (cell && cell.t === "n") cell.z = "#,##0";
    }
    workbook.SheetNames.push("Rejected Applications");
    workbook.Sheets["Rejected Applications"] = rejectedSheet;
  }

  if (underwriterRows && underwriterRows.length) {
    const underwriterHeader = [
      "S. No.",
      "Name",
      "CNIC / NTN",
      "Participant ID",
      "Account Number",
      "Shares Allotted",
      "Amount (Rs.)",
    ];
    let underwriterTotalShares = 0;
    let underwriterTotalAmount = 0;
    const underwriterDataRows = underwriterRows.map((u, index) => {
      const shares = Number(u.shares_allotted) || 0;
      const amount = Number(u.amount) || 0;
      underwriterTotalShares += shares;
      underwriterTotalAmount += amount;
      return [
        index + 1,
        u.name || "",
        u.cnic_ntn || "",
        u.participant_id || "",
        u.account_number || "",
        shares,
        amount,
      ];
    });
    const underwriterTotalRow = ["", "Total", "", "", "", underwriterTotalShares, underwriterTotalAmount];
    const underwriterSheet = xls.utils.aoa_to_sheet([
      underwriterHeader,
      ...underwriterDataRows,
      underwriterTotalRow,
    ]);
    underwriterSheet["!cols"] = [
      { wch: 8 },
      { wch: 26 },
      { wch: 18 },
      { wch: 16 },
      { wch: 18 },
      { wch: 16 },
      { wch: 16 },
    ];
    const underwriterRange = xls.utils.decode_range(underwriterSheet["!ref"]);
    for (let r = underwriterRange.s.r; r <= underwriterRange.e.r; r++) {
      [5, 6].forEach((c) => {
        const cell = underwriterSheet[xls.utils.encode_cell({ r, c })];
        if (cell && cell.t === "n") cell.z = "#,##0";
      });
    }
    workbook.SheetNames.push("Underwriter Allotment");
    workbook.Sheets["Underwriter Allotment"] = underwriterSheet;
  }

  const exported = xls.write(workbook, { bookType: "xlsx", type: "binary", cellStyles: true });
  saveAs(
    new Blob([s2ab(exported)], { type: "application/octet-stream" }),
    `${fileName}.xlsx`
  );
}
export function IsJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export function isValidDate(d) {
  const da = new Date(d);
  return da instanceof Date && !isNaN(da);
}

export function generateRegex(input) {
  var string = "^",
    arr = input.trim().split(" ");
  arr.forEach(function (chars, i) {
    string += chars + "\\w*" + (arr.length - 1 > i ? "\\s+" : "");
  });

  return new RegExp(string, "i");
}

// CDS Participant ID (max 5 digits) / Account Number (max 6 digits) input
// restriction, used everywhere either is entered by hand across the system
// — strips anything non-numeric and caps the length as the user types,
// instead of validating (and rejecting) only after the fact.
export const CDS_PARTICIPANT_ID_MAX_LENGTH = 5;
export const CDS_ACCOUNT_NUMBER_MAX_LENGTH = 6;
export function restrictDigits(value, maxLength) {
  return String(value || "")
    .replace(/\D/g, "")
    .slice(0, maxLength);
}

export function numberWithCommas(value) {
  if (value === "NaN" || value === NaN || value === "" || value === undefined || value === null) {
    return "";
  } else {
    return value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }
}

export function thousandSeperator(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
export function listCrud(features) {
  let crud;
  features.forEach((item) => {
    if (item.children.length > 0) {
      item.children.forEach((tem) => {
        const path = window.location.pathname;
        if (tem.route === path) {
          crud = tem.crud;
        }
      });
    }
  });
  return crud;
}
export function getFoundObject(array, itemToFind) {
  return array.find((id) => id.value === itemToFind) === undefined
    ? { label: "", value: "" }
    : array.find((id) => id.value === itemToFind);
}
export function getFilteredObjects(array, itemToFind) {
  return array.find((id) => id.value === itemToFind) === undefined
    ? null
    : array.find((id) => id.value === itemToFind);
}

export function findArrayObjcetBy(array, prop, value) {
  return array.find((item) => item[prop] === value);
}

export function filterArrayObjcetBy(array, prop, value) {
  return array.find((item) => item[prop] === value);
}
export function loopmessages(message) {
  message.forEach((item) => {
    toast.error(item);
  });
}

export function sortyByDate(array) {
  return array.sort((a, b) => {
    if (new Date(b.create_at).getTime() < new Date(a.create_at).getTime())
      return -1;
    if (new Date(b.create_at).getTime() > new Date(a.create_at).getTime())
      return 1;
    return 0;
  });
}

export function generateLetters(lot_size, shares, allotment_number) {
  const allotment_letters = [];
  let proportions = 0;
  let i = shares;
  while (i !== 0) {
    allotment_number++;
    if (i >= lot_size) {
      i = i - lot_size;
      allotment_letters.push({ shares_count: lot_size, allotment_number });
    } else if (i < lot_size && i > 0) {
      allotment_letters.push({ shares_count: i, allotment_number });
      i = 0;
    }
    proportions++;
  }
  return allotment_letters;
}

export function fileBase64(file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      resolve(reader.result);
    };
    reader.onerror = function (error) {
      reject(error);
    };
  });
}
export function isNumber(value) {
  if (
    value == NaN ||
    value == "NaN" ||
    value == undefined ||
    value == "undefined" ||
    value == "" ||
    value == null ||
    value == "null"
  ) {
    value = "0";
  }
  return value;
}

export function isDateValid(date) {
  if (date == "invalid" || date == "Invalid date") {
    date = "";
  }
  return date;
}
